import Button from "components/common/ui/Button/Button";
import IconClose from "components/common/ui/Icons/IconClose/IconClose";
import { StyledHeader } from "components/header/Header.Styled";
import useOutsideClick from "hooks/useOutsideClick";
import {
	StyledContainer,
	StyledContent,
	StyledHeading,
	StyledModalContentContainer,
	StyledOverlay,
} from "./loyalty.Styled";
import React, { useState } from "react";
import { InputText } from "components/common/form/Input/Input";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const LoyaltyAuthenticationModal = ({
	isOpen,
	handleClose,
	onValidate,
}: // children,
{
	isOpen: boolean;
	handleClose: () => void;

	onValidate: (code: string) => Promise<{ success: boolean; message?: string }>;
}) => {
	const closeModal = () => {
		handleClose();
		setVerificationCode("");
		setErrorMsg("");
	};
	const { t } = useTranslation();
	const ref = useOutsideClick(closeModal);
	const [verificationCode, setVerificationCode] = useState("");
	const [errorMsg, setErrorMsg] = useState("");

	const handleSubmit = async () => {
		if (!verificationCode.trim()) {
			setErrorMsg(t("loyaltyCard.2facode.required") as string);
			return;
		}

		const result = await onValidate(verificationCode);
		if (!result.success) {
			setErrorMsg(
				result.message || (t("loyaltyCard.2facode.invalidCode") as string),
			);
		}
	};

	return (
		<StyledContainer isOpen={isOpen}>
			<StyledOverlay>
				<StyledModalContentContainer ref={ref}>
					<StyledHeader>
						<StyledHeading>{t("loyaltyModalHeading")}</StyledHeading>
						<Button icon={<IconClose />} onClick={closeModal} />
					</StyledHeader>
					<StyledContent>
						<p>{t("loyaltyModalDescription")}</p>
						<InputText
							label={t("loyaltyModalLabel") as string}
							errorMsg={errorMsg}
							required
							onChange={(e) => setVerificationCode(e.target.value)}
							value={verificationCode}
						/>
						<Button
							variant="primary_01"
							onClick={handleSubmit}
							style={{ marginTop: "10px" }}
						>
							Potvrda
						</Button>
					</StyledContent>
				</StyledModalContentContainer>
			</StyledOverlay>
		</StyledContainer>
	);
};

export default LoyaltyAuthenticationModal;
